import { useContext } from 'react';
import * as React from 'react';
import { EPageTypes, EPlatformTypes, useDynamicPhone } from '@cian/frontend-newbuilding-call-component';
import { useDeviceType } from '@cian/ui-kit';
import { TPlaceType } from '../../types/promoDetails/callButton';
import { useApplicationContext } from '../../utils/applicationContext';
import { preparePhones, phoneToString } from '../../utils/phone';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';

interface IUserDynamicPhoneParams {
  placeType: TPlaceType;
}

export const useCalltracking = ({ placeType }: IUserDynamicPhoneParams) => {
  const { httpApi, logger } = useApplicationContext();

  const device = useDeviceType();

  const { siteBlockId, builder, offerId } = useContext(PromoOfferCardContext);

  const phones = builder?.phones;

  const formattedPhones = React.useMemo(() => preparePhones(phones || []), [phones]);

  const notFormattedPhone = React.useMemo(() => {
    if (!phones || phones.length === 0) {
      return '';
    }

    return phoneToString(phones[0]);
  }, [phones]);

  return useDynamicPhone({
    formattedPhone: formattedPhones[0].number as string,
    notFormattedPhone,
    siteBlockId: siteBlockId || null,
    httpApi,
    logger,
    placeType,
    pageType: EPageTypes.NewbuildingPromos,
    platformType: device === 'phone' ? EPlatformTypes.WebMobile : EPlatformTypes.WebDesktop,
    announcementId: offerId,
  });
};
